export default __webpack_public_path__ + "media/images/features/yado/message_sample-01e5a2d10fc7362d8a2dfd6cba5fe29c.png";